/**
 * Rarely accessory / add-on connections.
 * Used on the homepage hero, PDP buy box, cart, and "You Might Also Like".
 * Add a rule when a new obvious pair shows up. Missing products are skipped.
 */
(function (root) {
  var RULES = [
    {
      id: 'buffalo-ranching-gloves-kids',
      eyebrow: 'Same gloves, kid-sized',
      title: 'Kids ranching gloves',
      note: 'Rarely sells kid-sized buffalo leather ranching gloves — Kids Medium and Kids Large — plus kids extreme mittens.',
      match: { handles: ['buffalo-leather-ranching-gloves-1'] },
      addons: [
        'kids-buffalo-leather-ranching-gloves-rarely-edition',
        'kids-two-tone-buffalo-leather-ranching-gloves-rarely-edition',
        'kids-extreme-mittens-water-buffalo-leather-rarely-edition'
      ]
    },
    {
      id: 'emergency-fire-blanket',
      eyebrow: 'Build the fire kit',
      title: 'Heat, light, and ignition',
      note: 'Fire-ready companions for heat, light, and ignition.',
      match: { handles: ['emergency-fire-blanket'] },
      addons: [
        'fire-glove-heat-resistant-leather',
        'firerod-v2',
        'firefly-camping-gas-lantern'
      ]
    },
    {
      id: 'honka-wall-bars',
      eyebrow: 'The Finnish gym',
      title: 'OKSA completes HONKA',
      note: 'HONKA is the wall. OKSA is the bar that turns it into pull-ups, hangs, and dips — one piece of furniture that grows with them.',
      match: { any: ['honka', 'wall bar', 'wall-bars', 'wallbars'] },
      exclude: { any: ['oksa'] },
      addons: [
        'oksa-pull-up-bar-dip-station-birch-plywood-150-kg-capacity',
        'oksa-pull-up-bar-and-dip-station',
        'oksa-pull-up-bar-dip-station',
        'oksa-pull-up-bar',
        'oksa',
        'tuohi-ii-slide-ramp-birch-plywood-120cm',
        'tuohi'
      ]
    },
    {
      id: 'oksa-pull-up',
      eyebrow: 'Made for the wall bars',
      title: 'Pair with HONKA',
      note: 'OKSA only makes sense on HONKA. Together they are a compact gym that still looks like furniture.',
      match: { any: ['oksa', 'pull-up bar', 'pull up bar', 'dip station'] },
      exclude: { any: ['honka'] },
      addons: [
        'honka-wall-bars-birch-plywood-78cm-x-105cm',
        'honka-wall-bars',
        'honka'
      ]
    },
    {
      id: 'luoto-climbing-arch',
      eyebrow: 'The whole playground',
      title: 'Cushion, ramp, wedges, pads',
      note: 'LUOTO is the arch. Flip it, add KAURA, and it becomes a rocker. TUOHI is the slide. Wedges hold it still. Felt pads keep the floor honest.',
      match: { any: ['luoto'] },
      exclude: { any: ['kaura', 'tuohi', 'wedge', 'felt pad', 'felt-pad'] },
      addons: [
        'kaura-ii-cushion-for-luoto-ii-rocker-sand-150cm-x-55cm',
        'kaura-ii-cushion',
        'kaura-2-cushion',
        'kaura',
        'tuohi-ii-slide-ramp-birch-plywood-120cm',
        'tuohi-slide-ramp',
        'tuohi',
        'rocker-wedges-for-luoto-ii-climbing-arch-birch-plywood-set-of-4',
        'wedges-luoto',
        'luoto-wedges',
        'felt-pads-for-luoto-laakso-arches-birch-3-pack',
        'felt-pads-luoto',
        'luoto-felt-pads'
      ]
    },
    {
      id: 'kaura-cushion',
      eyebrow: 'Turns the arch into a rocker',
      title: 'Add LUOTO, then the rest',
      note: 'KAURA straps into the inverted LUOTO. Without the arch it is only a cushion. With it, the afternoon changes character.',
      match: { any: ['kaura'] },
      addons: [
        'luoto-ii-climbing-arch-birch-plywood-100-x-60-x-54-cm',
        'luoto-2-climbing-arch',
        'luoto-2',
        'luoto',
        'tuohi-ii-slide-ramp-birch-plywood-120cm',
        'tuohi',
        'rocker-wedges-for-luoto-ii-climbing-arch-birch-plywood-set-of-4'
      ]
    },
    {
      id: 'tuohi-ramp',
      eyebrow: 'The slide for the system',
      title: 'Add the arch — or the wall bars',
      note: 'TUOHI hangs on LUOTO or HONKA. One side slides. Flip it and the rungs become a climb.',
      match: { any: ['tuohi'] },
      addons: [
        'luoto-ii-climbing-arch-birch-plywood-100-x-60-x-54-cm',
        'luoto-2-climbing-arch',
        'luoto-2',
        'luoto',
        'honka-wall-bars-birch-plywood-78cm-x-105cm',
        'honka',
        'kaura-ii-cushion-for-luoto-ii-rocker-sand-150cm-x-55cm',
        'kaura'
      ]
    },
    {
      id: 'luoto-wedges',
      eyebrow: 'Steadies the rocker',
      title: 'Add LUOTO and KAURA',
      note: 'The wedges nest against the inverted arch so younger children can climb in without it rocking. Take them out when motion is the point.',
      match: { any: ['luoto', 'rocker wedge', 'wedges for luoto'] },
      exclude: { any: ['kaura', 'tuohi', 'felt pad'] },
      addons: [
        'luoto-ii-climbing-arch-birch-plywood-100-x-60-x-54-cm',
        'luoto',
        'kaura-ii-cushion-for-luoto-ii-rocker-sand-150cm-x-55cm',
        'kaura'
      ]
    },
    {
      id: 'luoto-felt-pads',
      eyebrow: 'The finishing detail',
      title: 'Add the climbing arch',
      note: 'Felt pads belong on LUOTO (and LAAKSO). They protect the floor and the birch wherever the wood moves.',
      match: { any: ['felt pad', 'felt-pad', 'felt pads'] },
      addons: [
        'luoto-ii-climbing-arch-birch-plywood-100-x-60-x-54-cm',
        'luoto'
      ]
    },
    {
      id: 'lempi-floor-cushion',
      eyebrow: 'The quiet half',
      title: 'Add the play canopy',
      note: 'LEMPI is the landing. LUMO is the little world over it. Together they are a reading den, a fort, a rest after the climb.',
      match: { any: ['lempi'] },
      exclude: { any: ['lumo'] },
      addons: [
        'lumo-play-canopy-vanilla',
        'lumo-play-canopy',
        'lumo'
      ]
    },
    {
      id: 'lumo-play-canopy',
      eyebrow: 'Needs a landing',
      title: 'Add the floor cushion',
      note: 'LUMO is the canopy. LEMPI is the cushion underneath. That is the nest.',
      match: { any: ['lumo', 'play canopy', 'play-canopy'] },
      exclude: { any: ['lempi'] },
      addons: [
        'lempi-floor-cushion-100cm-sand-polyester-fitwood',
        'lempi-floor-cushion',
        'lempi'
      ]
    },
    {
      id: 'senger-stuffed-animal',
      eyebrow: 'Build the reading nook',
      title: 'Book, cushion, canopy, blanket',
      note: 'A Senger animal wants a story, a soft landing, and a small den.',
      match: { vendors: ['senger naturwelt'], any: ['senger'] },
      addons: [
        'brown-bear-brown-bear-what-do-you-see-50th-anniversary-board-book-ages-2-5',
        'lempi-floor-cushion-100cm-sand-polyester-fitwood',
        'lempi-floor-cushion',
        'lempi',
        'lumo-play-canopy-vanilla',
        'lumo-play-canopy',
        'lumo',
        'avery-organic-cotton-knitted-baby-blanket-reversible-floral-print-poppy',
        'waffle-knit-baby-blanket-36-x-36-100-cotton',
        '6-layer-cotton-muslin-baby-blanket-fern-print',
        'charlie-farmhouse-quilted-play-mat'
      ]
    },
    {
      id: 'toverlux-silhouette',
      eyebrow: 'Needs the lamp',
      title: 'Add the Toverlux lamp',
      note: 'The silhouette is an insert. It lights up on the Toverlux base.',
      match: { any: ['toverlux', 'silhouette'] },
      exclude: { any: ['lamp', 'backlight', 'base'] },
      addons: ['toverlux-lamp-backlight-base-for-toverlux-silhouettes']
    },
    {
      id: 'toverlux-lamp',
      eyebrow: 'Needs a scene',
      title: 'Add a silhouette',
      note: 'The lamp is the backlight. Pick a scene to drop in.',
      match: { any: ['toverlux-lamp', 'backlight-base-for-toverlux'] },
      addons: [
        'vogel-geluk-silhouette-honeybees-toverlux-lamp-insert',
        'baukje-exler-silhouette-print-golden-hour-toverlux-translucent',
        'toverlux-silhouette-spring-dance',
        'moonlight-ballerina-silhouette-print-toverlux-translucent-insert',
        'baukje-exler-silhouette-winter-robin-toverlux-insert'
      ]
    },
    {
      id: 'field-flower-press',
      eyebrow: 'Keep pressing',
      title: 'Add refill boards',
      note: 'The press is reusable. Extra cardboard is what you actually use up.',
      match: { handles: ['field-flower-press-reusable-botanical-press-made-in-usa'] },
      addons: ['field-flower-press-refill-cardboard-10pcs']
    },
    {
      id: 'pocket-flower-press',
      eyebrow: 'Keep pressing',
      title: 'Add refill boards',
      note: 'The pocket press is reusable. Extra boards keep it working.',
      match: { handles: ['pocket-flower-press-reusable-wooden-press-made-in-usa'] },
      addons: ['flower-press-refill-boards-10-pack']
    },
    {
      id: 'flower-press-refill',
      eyebrow: 'Needs the press',
      title: 'Add a flower press',
      note: 'Refills only help if you already have the press.',
      match: { any: ['flower-press-refill', 'field-flower-press-refill'] },
      addons: [
        'field-flower-press-reusable-botanical-press-made-in-usa',
        'pocket-flower-press-reusable-wooden-press-made-in-usa'
      ]
    },
    {
      id: 'june-collecting-kit',
      eyebrow: 'For the field',
      title: 'Add a press and journal',
      note: 'Collect, press, then keep what you found.',
      match: { handles: ['beach-collecting-kit-forceps-bottles-botanical-labels', 'specimen-collecting-kit'] },
      addons: [
        'field-flower-press-reusable-botanical-press-made-in-usa',
        'pocket-flower-press-reusable-wooden-press-made-in-usa',
        'fern-herbarium-journal-forest-green-recycled-materials'
      ]
    },
    {
      id: 'june-journal',
      eyebrow: 'For the field',
      title: 'Add a collecting kit and press',
      note: 'The journal keeps what you found. A kit and a press are how you find it.',
      match: { handles: ['fern-herbarium-journal-forest-green-recycled-materials'] },
      addons: [
        'beach-collecting-kit-forceps-bottles-botanical-labels',
        'specimen-collecting-kit',
        'field-flower-press-reusable-botanical-press-made-in-usa',
        'pocket-flower-press-reusable-wooden-press-made-in-usa'
      ]
    },
    {
      id: 'spinning-top',
      eyebrow: 'Needs a plate',
      title: 'Add a spinning plate',
      note: 'A hardwood plate keeps the top from walking off the table.',
      match: { any: ['spinning-top', 'spinning top', 'apple-helene'] },
      exclude: { any: ['plate'] },
      addons: ['spinning-top-plate-25cm-walnut', 'spinning-top-plate-25cm-maple']
    },
    {
      id: 'spinning-plate',
      eyebrow: 'Needs a top',
      title: 'Add a spinning top',
      note: 'The plate is the stage. The top is the act.',
      match: { any: ['spinning-top-plate', 'spinning top plate'] },
      addons: [
        'rallye-striped-spinning-top-large-austrian-hardwood',
        'zwirbel-spinning-top-austrian-hardwood',
        'bonbon-spinning-top-8-colors',
        'apple-helene-top-with-spinning-rings-hand-turned-austrian-hardwood'
      ]
    },
    {
      id: 'plan-dollhouse',
      eyebrow: 'Furnish the house',
      title: 'Add the rooms',
      note: 'The house is the shell. The 1:12 sets fill it.',
      match: {
        handles: [
          'victorian-dollhouse-3-story-wooden-1-12-scale-plantoys',
          'grand-victorian-dollhouse-4-floor-rubberwood-24-76-x-13-19-x-28-03'
        ]
      },
      addons: [
        'dollhouse-furniture-set-1-12-scale-living-room-bedroom-kitchen-dining-room-bathroom',
        'classic-bedroom-dollhouse-set-1-12-scale-7-piece',
        'classic-childrens-bedroom-dollhouse-furniture-set-1-12-scale-bunk-bed-table-chair-toy-chest',
        'classic-dining-room-1-12-scale-dollhouse-furniture-set-plantoys'
      ]
    },
    {
      id: 'tender-leaf-dollhouse',
      eyebrow: 'Furnish the cottage',
      title: 'Add the accessory packages',
      note: 'The cottage is the shell. Tender Leaf furniture packages fill it.',
      match: {
        handles: [
          'cottontail-cottage-wooden-dollhouse-17-32-x-13-07-x-18-7',
          'rosewood-cottage-wooden-playhouse-16-5-x-15-75-x-12-2-tender-leaf-toys'
        ]
      },
      addons: [
        'countryside-furniture-set',
        'countryside-furniture-set-tender-leaf-toys',
        'cottontail-cottage-starter-furniture-set',
        'greenhouse-and-garden-set',
        'greenhouse-and-garden-set-tender-leaf-toys',
        'dollhouse-nursery-set',
        'dollhouse-nursery-set-tender-leaf-toys',
        'cottontail-cottage-wooden-dollhouse-17-32-x-13-07-x-18-7',
        'rosewood-cottage-wooden-playhouse-16-5-x-15-75-x-12-2-tender-leaf-toys',
        'victorian-dollhouse-3-story-wooden-1-12-scale-plantoys'
      ]
    },
    {
      id: 'dollhouse-furniture',
      eyebrow: 'Needs a house',
      title: 'Add the dollhouse',
      note: 'These sets are 1:12. They belong in the Victorian house.',
      match: { any: ['dollhouse-furniture', 'dollhouse set', '1-12-scale'] },
      exclude: { any: ['victorian-dollhouse', 'grand-victorian', 'cottontail', 'rosewood', 'tender leaf'] },
      addons: [
        'victorian-dollhouse-3-story-wooden-1-12-scale-plantoys',
        'grand-victorian-dollhouse-4-floor-rubberwood-24-76-x-13-19-x-28-03'
      ]
    },
    {
      id: 'tender-leaf-dollhouse-furniture',
      eyebrow: 'Needs a house',
      title: 'Add the cottage',
      note: 'These packages belong in Cottontail Cottage and Rosewood Cottage.',
      match: {
        any: [
          'countryside-furniture',
          'countryside furniture',
          'starter-furniture',
          'starter furniture',
          'greenhouse-and-garden',
          'greenhouse and garden',
          'dollhouse-nursery',
          'dollhouse nursery'
        ]
      },
      exclude: { any: ['cottontail-cottage-wooden', 'rosewood-cottage'] },
      addons: [
        'cottontail-cottage-wooden-dollhouse-17-32-x-13-07-x-18-7',
        'rosewood-cottage-wooden-playhouse-16-5-x-15-75-x-12-2-tender-leaf-toys'
      ]
    },
    {
      id: 'plan-dollhouse-future',
      eyebrow: 'Furnish the house',
      title: 'Add the rooms',
      note: 'The house is the shell. The 1:12 sets fill it.',
      match: { any: ['dollhouse'] },
      exclude: {
        any: [
          'furniture',
          'bedroom',
          'dining',
          'cottontail',
          'rosewood',
          'tender leaf',
          'playhouse',
          'nursery',
          'countryside'
        ]
      },
      addons: [
        'dollhouse-furniture-set-1-12-scale-living-room-bedroom-kitchen-dining-room-bathroom',
        'classic-bedroom-dollhouse-set-1-12-scale-7-piece',
        'classic-childrens-bedroom-dollhouse-furniture-set-1-12-scale-bunk-bed-table-chair-toy-chest',
        'classic-dining-room-1-12-scale-dollhouse-furniture-set-plantoys'
      ]
    },
    {
      id: 'qtoys-barn',
      eyebrow: 'Needs the stable',
      title: 'Add the horse stable',
      note: 'Barn and stable are the same wooden farm.',
      match: { handles: ['wooden-farm-barn-playset-l60-w40-h27-cm-rubberwood-acacia-or-hemlock'] },
      addons: ['wooden-horse-stable-rubber-wood-6-stalls']
    },
    {
      id: 'qtoys-stable',
      eyebrow: 'Needs the barn',
      title: 'Add the farm barn',
      note: 'The stalls want a barn next to them.',
      match: { handles: ['wooden-horse-stable-rubber-wood-6-stalls'] },
      addons: ['wooden-farm-barn-playset-l60-w40-h27-cm-rubberwood-acacia-or-hemlock']
    },
    {
      id: 'just-blocks-medium',
      eyebrow: 'More blocks',
      title: 'Step up to the big set',
      note: 'Same system. More pieces.',
      match: { handles: ['just-blocks-basic-medium-68-beech-plywood-blocks-polish-natural-wooden-set'] },
      addons: ['just-blocks-basic-big-160-piece-beech-plywood-block-set']
    },
    {
      id: 'just-blocks-big',
      eyebrow: 'Same system',
      title: 'The medium set too',
      note: 'Same beech plywood language. Medium is the everyday set; Big is the room.',
      match: { handles: ['just-blocks-basic-big-160-piece-beech-plywood-block-set'] },
      addons: ['just-blocks-basic-medium-68-beech-plywood-blocks-polish-natural-wooden-set']
    },
    {
      id: 'fagus-wheels-dumper',
      eyebrow: 'Needs the trailer',
      title: 'Add the dumper trailer',
      note: 'The wheels dumper and trailer hitch as one wooden dump set.',
      match: { handles: ['wheels-dumper-steerable-wooden-toy-dump-truck-with-tippable-bed'] },
      addons: ['dumper-trailer']
    },
    {
      id: 'cuboro-marble-set',
      eyebrow: 'Finish the run',
      title: 'Marbles and the book',
      note: 'A Cuboro set wants extra marbles and The Book — most people take both.',
      match: {
        handles: [
          'junior-marble-run-set',
          'standard-32-marble-run-set',
          'standard-50-marble-run-set',
          'speed-marble-run-extra-set-expansion-pack',
          'trick-marble-run-extra-set',
          'kick-marble-run-extra-set-add-on-track-pieces'
        ]
      },
      addons: [
        'marbles-for-marble-run',
        'cuboro-the-book-for-marble-runs',
        'junior-marble-run-set',
        'standard-32-marble-run-set',
        'standard-50-marble-run-set',
        'speed-marble-run-extra-set-expansion-pack',
        'trick-marble-run-extra-set',
        'kick-marble-run-extra-set-add-on-track-pieces'
      ]
    },
    {
      id: 'cuboro-marbles',
      eyebrow: 'Complete the run',
      title: 'Add the book and a set',
      note: 'Marbles belong with Cuboro The Book and a marble run set.',
      match: { handles: ['marbles-for-marble-run'] },
      addons: [
        'cuboro-the-book-for-marble-runs',
        'junior-marble-run-set',
        'standard-32-marble-run-set',
        'standard-50-marble-run-set',
        'speed-marble-run-extra-set-expansion-pack',
        'trick-marble-run-extra-set',
        'kick-marble-run-extra-set-add-on-track-pieces'
      ]
    },
    {
      id: 'cuboro-book',
      eyebrow: 'Complete the run',
      title: 'Add marbles and a set',
      note: 'The Book is the map. Marbles and a Cuboro set are the run.',
      match: { handles: ['cuboro-the-book-for-marble-runs'] },
      addons: [
        'marbles-for-marble-run',
        'junior-marble-run-set',
        'standard-32-marble-run-set',
        'standard-50-marble-run-set',
        'speed-marble-run-extra-set-expansion-pack',
        'trick-marble-run-extra-set',
        'kick-marble-run-extra-set-add-on-track-pieces'
      ]
    },
    {
      id: 'cuboro-system',
      eyebrow: 'The Cuboro system',
      title: 'Marbles, book, and sets',
      note: 'Cuboro pieces work as one marble-run system.',
      match: { vendors: ['cuboro'], any: ['cuboro'] },
      addons: [
        'marbles-for-marble-run',
        'cuboro-the-book-for-marble-runs',
        'junior-marble-run-set',
        'standard-32-marble-run-set',
        'standard-50-marble-run-set',
        'speed-marble-run-extra-set-expansion-pack',
        'trick-marble-run-extra-set',
        'kick-marble-run-extra-set-add-on-track-pieces'
      ]
    },
    {
      id: 'sabo-kitchen-tea',
      eyebrow: 'Set the table',
      title: 'Kitchen and tea',
      note: 'Sabo kitchens and tea sets are the same painted wood — they belong on the same floor.',
      match: {
        handles: [
          'wooden-kitchen-set-15-pieces-ages-3',
          'wooden-play-kitchen-set-14-piece-flower-print-age-3',
          'wooden-tea-set-14-pieces-flower-linden-birch-ages-3',
          'wooden-tea-set-19-pieces-sabo-concept'
        ]
      },
      addons: [
        'wooden-kitchen-set-15-pieces-ages-3',
        'wooden-play-kitchen-set-14-piece-flower-print-age-3',
        'wooden-tea-set-14-pieces-flower-linden-birch-ages-3',
        'wooden-tea-set-19-pieces-sabo-concept',
        'wooden-rainbow-stacking-arches-flower-meadow-6-8-mini',
        'wooden-forest-set-10-trees-linden-or-birch-sabo-concept',
        'great-kingdom-wooden-blocks-65-piece-set-linden-wood',
        'italian-courtyard-wooden-blocks-59-pieces-sabo-concept'
      ]
    },
    {
      id: 'sabo-city-blocks',
      eyebrow: 'The wooden city',
      title: 'More blocks from the same world',
      note: 'Kingdom, courtyard, ancient city, and forest are one Sabo city — they stack as a set.',
      match: {
        handles: [
          'great-kingdom-wooden-blocks-65-piece-set-linden-wood',
          'italian-courtyard-wooden-blocks-59-pieces-sabo-concept',
          'italy-ancient-city-wooden-blocks-103-pieces-santa-maria-assunta-model',
          'wooden-forest-set-10-trees-linden-or-birch-sabo-concept',
          'trees-set-thujas-linden-wood-3-piece',
          'wooden-castle-blocks-41-piece-set-linden-birch',
          'wooden-alphabet-blocks-26-cubes-4cm-a-z-made-in-ukraine',
          'wooden-blocks-set-24-multicolored-cubes-4cm-ages-1-5'
        ]
      },
      addons: [
        'great-kingdom-wooden-blocks-65-piece-set-linden-wood',
        'italian-courtyard-wooden-blocks-59-pieces-sabo-concept',
        'wooden-forest-set-10-trees-linden-or-birch-sabo-concept',
        'wooden-rainbow-stacking-arches-flower-meadow-6-8-mini',
        'wooden-kitchen-set-15-pieces-ages-3',
        'italy-ancient-city-wooden-blocks-103-pieces-santa-maria-assunta-model',
        'wooden-castle-blocks-41-piece-set-linden-birch',
        'trees-set-thujas-linden-wood-3-piece',
        'wooden-alphabet-blocks-26-cubes-4cm-a-z-made-in-ukraine',
        'wooden-blocks-set-24-multicolored-cubes-4cm-ages-1-5'
      ]
    },
    {
      id: 'sabo-rainbow-stacker',
      eyebrow: 'Keep stacking',
      title: 'More Sabo arches and rings',
      note: 'Rainbows and ring stackers are the same painted linden — then the rest of the set.',
      match: {
        handles: [
          'wooden-rainbow-stacking-arches-flower-meadow-6-8-mini',
          'wooden-rainbow-arch-stacker-7-pieces-linden-or-birch-10-2-x-5-1',
          'wooden-ring-stacker-water-based-paint-sabo-concept-ukraine',
          'wooden-ring-stacker-muted-earthy-colors-4-9-x-4-9-x-8-1',
          'wooden-ring-stacker-8-1-tall-made-in-ukraine'
        ]
      },
      addons: [
        'wooden-rainbow-stacking-arches-flower-meadow-6-8-mini',
        'wooden-forest-set-10-trees-linden-or-birch-sabo-concept',
        'wooden-kitchen-set-15-pieces-ages-3',
        'wooden-tea-set-14-pieces-flower-linden-birch-ages-3',
        'great-kingdom-wooden-blocks-65-piece-set-linden-wood',
        'wooden-rainbow-arch-stacker-7-pieces-linden-or-birch-10-2-x-5-1',
        'wooden-ring-stacker-water-based-paint-sabo-concept-ukraine',
        'wooden-ring-stacker-muted-earthy-colors-4-9-x-4-9-x-8-1',
        'wooden-ring-stacker-8-1-tall-made-in-ukraine'
      ]
    },
    {
      id: 'sabo-journey',
      eyebrow: 'The same voyage',
      title: 'More from the wooden world',
      note: 'Journeys, sailboats, and the lighthouse share one coastal set — then the rest of Sabo.',
      match: {
        handles: [
          'first-journey-play-set-wooden-lion-in-car-with-landscape-natural-beech-linden',
          'quiet-journey-wooden-sailboat-play-set-32-x-9-x-16-5-cm',
          'sea-adventure-wooden-play-set-sailboat-lighthouse-coastal-landscape-28-5-x-15-5-x-20-cm',
          'wooden-lighthouse-4-5-x-4-5-x-20-cm-natural-beech-linden'
        ]
      },
      addons: [
        'wooden-forest-set-10-trees-linden-or-birch-sabo-concept',
        'great-kingdom-wooden-blocks-65-piece-set-linden-wood',
        'italian-courtyard-wooden-blocks-59-pieces-sabo-concept',
        'wooden-kitchen-set-15-pieces-ages-3',
        'italy-ancient-city-wooden-blocks-103-pieces-santa-maria-assunta-model',
        'quiet-journey-wooden-sailboat-play-set-32-x-9-x-16-5-cm',
        'sea-adventure-wooden-play-set-sailboat-lighthouse-coastal-landscape-28-5-x-15-5-x-20-cm',
        'first-journey-play-set-wooden-lion-in-car-with-landscape-natural-beech-linden',
        'wooden-lighthouse-4-5-x-4-5-x-20-cm-natural-beech-linden'
      ]
    },
    {
      id: 'sabo-rattle',
      eyebrow: 'More to hold',
      title: 'Rattles, then the rest of Sabo',
      note: 'Sabo rattles belong with the other small painted pieces — then the bigger sets.',
      match: {
        handles: [
          'balls-rolling-rattle-beech-linden-lagoon',
          'rings-rattle-beech-wood-natural',
          'flower-rattle-beech-beeswax-natural'
        ]
      },
      addons: [
        'wooden-rainbow-stacking-arches-flower-meadow-6-8-mini',
        'wooden-kitchen-set-15-pieces-ages-3',
        'wooden-tea-set-14-pieces-flower-linden-birch-ages-3',
        'wooden-forest-set-10-trees-linden-or-birch-sabo-concept',
        'balls-rolling-rattle-beech-linden-lagoon',
        'rings-rattle-beech-wood-natural',
        'flower-rattle-beech-beeswax-natural'
      ]
    },
    {
      id: 'sabo-system',
      eyebrow: 'The same maker',
      title: 'More Sabo Concept',
      note: 'Sabo pieces are one painted-wood world — they bundle with each other.',
      match: { vendors: ['sabo concept'], any: ['sabo'] },
      addons: [
        'great-kingdom-wooden-blocks-65-piece-set-linden-wood',
        'wooden-kitchen-set-15-pieces-ages-3',
        'italian-courtyard-wooden-blocks-59-pieces-sabo-concept',
        'wooden-tea-set-14-pieces-flower-linden-birch-ages-3',
        'wooden-rainbow-stacking-arches-flower-meadow-6-8-mini',
        'wooden-play-kitchen-set-14-piece-flower-print-age-3',
        'wooden-tea-set-19-pieces-sabo-concept',
        'italy-ancient-city-wooden-blocks-103-pieces-santa-maria-assunta-model',
        'wooden-forest-set-10-trees-linden-or-birch-sabo-concept'
      ]
    },
    {
      id: 'fagus-dumper-trailer',
      eyebrow: 'Needs the dumper',
      title: 'Add the wheels dumper',
      note: 'The trailer wants the wheels dumper it hitches to.',
      match: { handles: ['dumper-trailer'] },
      addons: ['wheels-dumper-steerable-wooden-toy-dump-truck-with-tippable-bed']
    },
    {
      id: 'fagus-car-transporter',
      eyebrow: 'Load the deck',
      title: 'Add the van and car',
      note: 'The transporter is built to carry the Fagus van and Speedy Car.',
      match: { handles: ['car-transporter'] },
      addons: ['van', 'speedy-car']
    },
    {
      id: 'fagus-van',
      eyebrow: 'Needs a ride',
      title: 'Add the transporter and car',
      note: 'The van belongs on the car transporter, with the Speedy Car.',
      match: { handles: ['van'] },
      addons: ['car-transporter', 'speedy-car']
    },
    {
      id: 'fagus-speedy-car',
      eyebrow: 'Needs a ride',
      title: 'Add the transporter and van',
      note: 'The Speedy Car belongs on the car transporter, with the van.',
      match: { handles: ['speedy-car'] },
      addons: ['car-transporter', 'van']
    },
    {
      id: 'fagus-truck',
      eyebrow: 'More vehicles',
      title: 'Add another wooden truck',
      note: 'Fagus trucks share the same scale and figures.',
      match: {
        any: ['wooden-jeep-toy', 'unimog-wooden-truck', 'wheels-dumper', 'fire-engine', 'wheel-loader']
      },
      addons: [
        'wooden-jeep-toy-steerable-2-figures-fagus-11',
        'unimog-wooden-truck-steerable-9-8-2-figures-included',
        'wheels-dumper-steerable-wooden-toy-dump-truck-with-tippable-bed',
        'fire-engine',
        'wheel-loader'
      ]
    },
    {
      id: 'fagus-system',
      eyebrow: 'More vehicles',
      title: 'Add another Fagus truck',
      note: 'Fagus vehicles share the same scale and figures.',
      match: { vendors: ['fagus'], any: ['fagus'] },
      addons: [
        'wooden-jeep-toy-steerable-2-figures-fagus-11',
        'unimog-wooden-truck-steerable-9-8-2-figures-included',
        'wheels-dumper-steerable-wooden-toy-dump-truck-with-tippable-bed',
        'fire-engine',
        'wheel-loader',
        'car-transporter',
        'van',
        'speedy-car'
      ]
    },
    {
      id: 'banwood-ride',
      eyebrow: 'Ride ready',
      title: 'Helmet, pads, basket',
      note: 'If they are on a Banwood, they need the gear that goes with it.',
      match: { any: ['banwood'] },
      exclude: { any: ['helmet', 'protective-gear', 'basket'] },
      addons: [
        'banwood-kids-helmet-matte-beige-50-54-cm',
        'banwood-protective-gear-3-pack-ages-3',
        'banwood-pin-ride-basket-recycled-rubber-ivory',
        'banwood-basket-pins-flower-recycled-rubber'
      ]
    },
    {
      id: 'banwood-gear',
      eyebrow: 'Needs a ride',
      title: 'Add a Banwood',
      note: 'Helmet, pads, and basket belong on a Banwood bike, scooter, or board.',
      match: { any: ['banwood'] },
      addons: [
        'banwood-first-go-balance-bike-cream-12-adjustable-37-44cm-saddle',
        'banwood-scooter-vintage-cream-3-wheel-oak-deck-ages-3',
        'banwood-trike-steel-frame-vintage-finish-ages-3-6',
        'banwood-kids-cruiser-skateboard-canadian-maple-ages-3',
        'banwood-maxi-scooter-vintage-green-oak-deck-ages-6',
        'banwood-kids-helmet-matte-beige-50-54-cm',
        'banwood-protective-gear-3-pack-ages-3'
      ]
    },
    {
      id: 'wobbel-board',
      eyebrow: 'Softer landing',
      title: 'Add a play mat and figures',
      note: 'The board is the motion. A mat and loose parts make it a room.',
      match: { any: ['wobbel'] },
      addons: [
        'charlie-farmhouse-quilted-play-mat',
        'kendi-quilted-playmat-cotton-safari-print',
        'nins-tomten-play-set-6-figures-42-loose-parts-grapat',
        'abel-golden-ratio-mini-blocks-24-piece-set'
      ]
    },
    {
      id: 'kids-bushcraft-kit',
      eyebrow: 'For the woods',
      title: 'Fire, sight, and gloves',
      note: 'The books are the map. A ferro rod, a monocular, and kids ranching gloves make it a kit.',
      match: {
        handles: ['bushcraft-boxed-set-by-dave-canterbury', 'kids-bushcraft-knife-rounded-tip-walnut-handle-7-overall']
      },
      addons: [
        'firerod-v2',
        'zoom-tube-monocular-8x32-six-colors',
        'kids-buffalo-leather-ranching-gloves-rarely-edition',
        'kids-two-tone-buffalo-leather-ranching-gloves-rarely-edition',
        'kids-extreme-mittens-water-buffalo-leather-rarely-edition',
        'baton-4-powerful-edc-flashlight-1300-lumens',
        'kids-travel-backpack-weewander-14-pockets'
      ]
    },
    {
      id: 'kids-gloves',
      eyebrow: 'For the field',
      title: 'Mittens, fire, and a book',
      note: 'Kids ranching gloves belong with the other kid-sized pair, a ferro rod, and the bushcraft books.',
      match: {
        handles: [
          'kids-buffalo-leather-ranching-gloves-rarely-edition',
          'kids-two-tone-buffalo-leather-ranching-gloves-rarely-edition',
          'kids-extreme-mittens-water-buffalo-leather-rarely-edition'
        ]
      },
      addons: [
        'kids-buffalo-leather-ranching-gloves-rarely-edition',
        'kids-two-tone-buffalo-leather-ranching-gloves-rarely-edition',
        'kids-extreme-mittens-water-buffalo-leather-rarely-edition',
        'bushcraft-boxed-set-by-dave-canterbury',
        'firerod-v2',
        'zoom-tube-monocular-8x32-six-colors'
      ]
    },
    {
      id: 'kids-fire-rod',
      eyebrow: 'For the woods',
      title: 'Books, monocular, gloves',
      note: 'A ferro rod wants the bushcraft books, a Zoom Tube, and kids ranching gloves.',
      match: { handles: ['firerod-v2', 'firerod-v2-1'] },
      addons: [
        'bushcraft-boxed-set-by-dave-canterbury',
        'zoom-tube-monocular-8x32-six-colors',
        'kids-buffalo-leather-ranching-gloves-rarely-edition',
        'baton-4-powerful-edc-flashlight-1300-lumens'
      ]
    },
    {
      id: 'kids-olight-baton',
      eyebrow: 'For the trail',
      title: 'Sight and fire',
      note: 'The Baton 4 is the light. A monocular and a ferro rod finish the kit.',
      match: { handles: ['baton-4-powerful-edc-flashlight-1300-lumens'], from: ['rarely-young'] },
      addons: [
        'zoom-tube-monocular-8x32-six-colors',
        'firerod-v2',
        'bushcraft-boxed-set-by-dave-canterbury',
        'kids-buffalo-leather-ranching-gloves-rarely-edition'
      ]
    },
    {
      id: 'olight-baton-adult',
      eyebrow: 'Along with this',
      title: 'Toyo, gloves, and a hatchet',
      note: 'The same companions that sit with the Baton 4 on the homepage.',
      match: { handles: ['baton-4-powerful-edc-flashlight-1300-lumens'] },
      addons: [
        'toyo-steel-stackable-storage-box-t-190',
        'buffalo-leather-ranching-gloves-1',
        'ax3-woodcraft-bushcraft-splitting-axe',
        'toyo-steel-stackable-storage-box-t-150',
        'toyo-steel-stackable-storage-box-t-152',
        'coal-tote-forest',
        'firefly-camping-gas-lantern'
      ]
    },
    {
      id: 'kids-weewander',
      eyebrow: 'Pack it',
      title: 'Field kit for the bag',
      note: 'The backpack wants something to carry — collecting kit, press, or bushcraft books.',
      match: { handles: ['kids-travel-backpack-weewander-14-pockets'], vendors: ['weewander'] },
      addons: [
        'beach-collecting-kit-forceps-bottles-botanical-labels',
        'specimen-collecting-kit',
        'field-flower-press-reusable-botanical-press-made-in-usa',
        'bushcraft-boxed-set-by-dave-canterbury',
        'zoom-tube-monocular-8x32-six-colors'
      ]
    },
    {
      id: 'broom-dustpans',
      eyebrow: 'Complete the pair',
      title: 'Add a handmade dustpan',
      note: 'A handmade dustpan for the day’s sweepings.',
      match: { handles: ['the-hand-broom', 'the-everyday-broom', 'the-cottage-broom', 'authentic-handmade-farmhouse-broomcorn-broom', 'the-homestead-broom-handmade-55', 'the-cinder-broom', 'homestead-hand-broom-natural-broomcorn-handcrafted-in-arkansas', 'little-helper-kids-broom-handcrafted-broomcorn-child-sized'] },
      addons: [
        'handmade-metal-dustpan-solid-hardwood-handle-made-in-usa',
        'handmade-walnut-dustpan-leather-loop-amish-crafted',
        'solid-copper-amish-dustpan-handmade-heirloom-cleaning-tool'
      ]
    },
    {
      id: 'kids-broom',
      eyebrow: 'Little helper',
      title: 'Add a play kitchen',
      note: 'A child-sized broom belongs next to a wooden kitchen.',
      match: { handles: ['little-helper-kids-broom-handcrafted-broomcorn-child-sized'] },
      addons: [
        'wooden-kitchen-set-15-pieces-ages-3',
        'wooden-play-kitchen-set-14-piece-flower-print-age-3',
        'wooden-tea-set-14-pieces-flower-linden-birch-ages-3'
      ]
    },
    {
      id: 'nocs-optics',
      eyebrow: 'See farther',
      title: 'Monocular, binoculars, kit',
      note: 'NOCS glass belongs with the other optics — then a pouch and a lens kit.',
      match: { vendors: ['nocs provisions'], any: ['nocs', 'zoom-tube', 'zero-tube'] },
      addons: [
        'zoom-tube-monocular-8x32-six-colors',
        'standard-issue-8x25-waterproof-binoculars-bak4-prisms-nitrogen-filled',
        'inspector-microscope-4x-magnification-macro-attachment-for-nocs-monoculars',
        '25mm-binocular-pouch-recycled-fabric-nocloc-quick-connect',
        'lens-cleaning-kit-30ml-solution-brush-blower-microfiber-cloth',
        'bushcraft-boxed-set-by-dave-canterbury'
      ]
    },
    {
      id: 'grapat-birds',
      eyebrow: 'More birds',
      title: 'The other Grapat birds',
      note: 'Flowing, Mellow, and Chill are one flock.',
      match: { any: ['yellow-bird', 'orange-bird', 'pink-bird', 'bird-hand-toy', 'bird rocking'] },
      addons: [
        'flowing-yellow-bird-hand-toy',
        'mellow-orange-bird-hand-toy',
        'chill-pink-bird-rocking-toy-hand-toy',
        'nins-tomten-play-set-6-figures-42-loose-parts-grapat'
      ]
    },
    {
      id: 'grapat-nins',
      eyebrow: 'Loose parts',
      title: 'More Grapat figures',
      note: 'Nins, coins, rings, and mandalas are one Grapat language.',
      match: {
        any: ['nins', 'mandala', 'tomten', 'dear-universe', 'happy-place', '18-rings', '36-coins', 'bowls-and-marbles', 'woodland-building']
      },
      addons: [
        'nins-tomten-play-set-6-figures-42-loose-parts-grapat',
        'nins-mates-and-coins',
        'nins-rings-coins-natural-wood',
        '18-rings-6-complementary-colors',
        '36-coins-12-colors',
        'bowls-and-marbles',
        'grapat-mandala-mix-warm',
        'mandala-trees',
        'dear-universe-play-set',
        'happy-place-play-set'
      ]
    },
    {
      id: 'grapat-system',
      eyebrow: 'The same maker',
      title: 'More Grapat',
      note: 'Grapat pieces are one wooden world — they bundle with each other.',
      match: { vendors: ['grapat'], any: ['grapat'] },
      addons: [
        'nins-tomten-play-set-6-figures-42-loose-parts-grapat',
        'woodland-building-set-18-tubes-9-walkways-hand-painted-wooden-blocks',
        '18-rings-6-complementary-colors',
        'nins-rings-coins-natural-wood',
        'bowls-and-marbles',
        'abel-golden-ratio-mini-blocks-24-piece-set'
      ]
    },
    {
      id: 'abel-blocks',
      eyebrow: 'Keep stacking',
      title: 'More Abel blocks',
      note: 'Abel blocks are one golden-ratio system. Size up, or add Grapat figures.',
      match: { vendors: ['abel'], any: ['abel'] },
      addons: [
        'abel-golden-ratio-mini-blocks-24-piece-set',
        'abel-blocks-12',
        'abel-mini-blocks-66',
        'nins-tomten-play-set-6-figures-42-loose-parts-grapat',
        'just-blocks-basic-medium-68-beech-plywood-blocks-polish-natural-wooden-set'
      ]
    },
    {
      id: 'filana-crayons',
      eyebrow: 'Keep drawing',
      title: 'More Filana, then the holder',
      note: 'Stick and block, classic and skintone — then the walnut holder they live in.',
      match: { vendors: ['filana beeswax crayons'], any: ['filana', 'walnut-crayon-holder'] },
      addons: [
        'filana-organic-beeswax-crayons-12-classic-colors-recycled-paper-box',
        'filana-organic-beeswax-block-crayons-12-classic-colors-made-with-20-certified-organic-beeswax',
        'filana-organic-beeswax-crayons-12-skin-tone-colors-stick-format',
        'filana-organic-beeswax-block-crayons-12-skintones',
        'walnut-crayon-holder-12-stick-12-block-handcrafted'
      ]
    },
    {
      id: 'qtoys-loose',
      eyebrow: 'More QToys',
      title: 'Farm, ship, balls',
      note: 'QToys wood is one farm-and-water set.',
      match: { vendors: ['qtoys'], any: ['qtoys'] },
      addons: [
        'wooden-farm-barn-playset-l60-w40-h27-cm-rubberwood-acacia-or-hemlock',
        'wooden-horse-stable-rubber-wood-6-stalls',
        'acacia-hardwood-toy-ship-40-x-14-x-35-cm-2',
        '35mm-wooden-balls-set-of-12-rubber-wood-non-toxic-color-finish'
      ]
    },
    {
      id: 'viverano-blanket',
      eyebrow: 'Make it a nest',
      title: 'Blanket and a knit friend',
      note: 'Viverano blankets want another blanket, or a knit animal to hold.',
      match: { vendors: ['viverano organics'], any: ['viverano'] },
      addons: [
        'dove-white-classic-pointelle-knit-baby-blanket-organic-cotton',
        'avery-organic-cotton-knitted-baby-blanket-reversible-floral-print-poppy',
        'waffle-knit-baby-blanket-36-x-36-100-cotton',
        'elephant-organic-cotton-knit-stuffed-animal',
        'organic-cotton-knit-lion-stuffed-animal-baby-toy',
        'handmade-baby-bear-white-6-5-plush',
        'lempi-floor-cushion-100cm-sand-polyester-fitwood'
      ]
    },
    {
      id: 'crane-blanket',
      eyebrow: 'Make it a nest',
      title: 'Play mat and a friend',
      note: 'A Crane blanket wants a play mat and something to hold.',
      match: { vendors: ['crane baby'] },
      exclude: { any: ['play-mat', 'playmat', 'play mat'] },
      addons: [
        'charlie-farmhouse-quilted-play-mat',
        'kendi-quilted-playmat-cotton-safari-print',
        'avery-organic-cotton-knitted-baby-blanket-reversible-floral-print-poppy',
        'waffle-knit-baby-blanket-36-x-36-100-cotton',
        'handmade-baby-bear-white-6-5-plush',
        'lempi-floor-cushion-100cm-sand-polyester-fitwood'
      ]
    },
    {
      id: 'upseat-nursery',
      eyebrow: 'The nursery',
      title: 'Seat, pad, and a rest',
      note: 'Upseat pieces belong together — then a rocker or a blanket.',
      match: { vendors: ['upseat'], any: ['upseat'] },
      addons: [
        'upseat-baby-floor-booster-seat-with-tray-anterior-pelvic-tilt-design',
        'upseat-changing-pad-extra-large-water-resistant',
        'upseat-backless-booster-car-seat-ages-4-40-120-lbs-rigid-latch-wipe-clean-polyurethane',
        'baby-rocker-for-ages-0-24-months-beech-eucalyptus-removable-muslin-cushion',
        'avery-organic-cotton-knitted-baby-blanket-reversible-floral-print-poppy'
      ]
    },
    {
      id: 'comfy-cubs-rocker',
      eyebrow: 'A rest after',
      title: 'Blanket and a seat',
      note: 'The rocker wants a blanket and a booster nearby.',
      match: { vendors: ['comfy cubs'], any: ['baby-rocker', 'baby rocker'] },
      addons: [
        'avery-organic-cotton-knitted-baby-blanket-reversible-floral-print-poppy',
        'waffle-knit-baby-blanket-36-x-36-100-cotton',
        'upseat-baby-floor-booster-seat-with-tray-anterior-pelvic-tilt-design',
        'lempi-floor-cushion-100cm-sand-polyester-fitwood',
        'handmade-baby-bear-white-6-5-plush'
      ]
    },
    {
      id: 'millstream-baskets',
      eyebrow: 'The other basket',
      title: 'Hamper and laundry basket',
      note: 'Amish seagrass — hamper and basket are the same weave.',
      match: {
        handles: [
          'handwoven-seagrass-hamper-24-x-19-x-13-amish-made',
          'handwoven-seagrass-laundry-basket-leather-handles-23-x-16-x-11'
        ]
      },
      addons: [
        'handwoven-seagrass-hamper-24-x-19-x-13-amish-made',
        'handwoven-seagrass-laundry-basket-leather-handles-23-x-16-x-11'
      ]
    },
    {
      id: 'kitchen-knives',
      eyebrow: 'Build the set',
      title: 'The other knives — then a board',
      note: 'One knife is a start. The set is the point. A board is what they work on.',
      match: { vendors: ['messermeister'] },
      exclude: { any: ['adventure chef', 'adventure-chef', 'summit-set', 'summit set'] },
      addons: [
        'custom-8-inch-chef-s-knife',
        'custom-3-5-inch-paring-knife',
        'custom-7-inch-kullenscliff-santoku',
        '98274672920-chefs-cutting-board-black-walnut',
        'nakiri-knife-6-5-german-steel-solingen',
        '6-inch-utility-knife-german-stainless-steel-linen-micarta-handle-solingen',
        'messermeister-multi-shears-9-titanium-coated-blades-push-button-disassembly',
        '98274672920-chefs-cutting-board-white-oak',
        '98274672920-chefs-chopping-block-black-walnut',
        '98274672920-chefs-chopping-block-white-oak',
        '18-walnut-live-edge-presentation-cutting-board',
        '18-cherry-live-edge-presentation-cutting-board'
      ]
    },
    {
      id: 'kitchen-knife-packs',
      eyebrow: 'For the counter',
      title: 'Salt, pepper, and a board',
      note: 'The pack covers the field. Mills and a board cover the kitchen.',
      match: {
        handles: [
          'adventure-chef-maple-summit-set-6-piece-folding-knife-set-german-x50-steel-carbonized-maple-handles',
          'messermeister-adventure-chef-linen-summit-set-6-piece-portable-cooking-kit-german-x50-steel'
        ],
        any: ['adventure-chef', 'summit-set']
      },
      addons: [
        'billund-grinder-2-pc-set-4-5',
        '98274672920-chefs-cutting-board-black-walnut',
        '98274672920-chefs-cutting-board-white-oak',
        'custom-8-inch-chef-s-knife',
        '18-walnut-live-edge-presentation-cutting-board'
      ]
    },
    {
      id: 'cutting-boards',
      eyebrow: 'Needs a knife',
      title: 'Add the kitchen knives',
      note: 'A board without a knife is furniture. These are the blades that belong on it.',
      match: {
        handles: [
          '98274672920-chefs-cutting-board-black-walnut',
          '98274672920-chefs-cutting-board-white-oak',
          '98274672920-chefs-chopping-block-black-walnut',
          '98274672920-chefs-chopping-block-white-oak',
          '98274672920-book-of-boards-black-walnut',
          '98274672920-book-of-boards-white-oak',
          '98274672920-signature-round-block-black-walnut',
          '98274672920-signature-round-block-white-oak',
          '18-cherry-live-edge-presentation-cutting-board',
          '18-walnut-live-edge-presentation-cutting-board',
          'double-live-edge-cutting-and-presentation-boards'
        ],
        any: [
          'cutting board',
          'chopping block',
          'book of boards',
          'book-of-boards',
          'live-edge',
          'live edge',
          'signature-round-block',
          'chefs-cutting-board',
          'chefs-chopping-block'
        ]
      },
      exclude: { any: ['tonic', 'walrus', 'care kit', 'wobbel'] },
      addons: [
        'custom-8-inch-chef-s-knife',
        'custom-3-5-inch-paring-knife',
        'custom-7-inch-kullenscliff-santoku',
        'nakiri-knife-6-5-german-steel-solingen',
        '6-inch-utility-knife-german-stainless-steel-linen-micarta-handle-solingen',
        'messermeister-multi-shears-9-titanium-coated-blades-push-button-disassembly'
      ]
    },
    {
      id: 'crane-play-mat',
      eyebrow: 'Make it a nest',
      title: 'Blanket and a Senger friend',
      note: 'A play mat wants something soft and something to hold.',
      match: { any: ['play-mat', 'playmat', 'play mat'] },
      addons: [
        'avery-organic-cotton-knitted-baby-blanket-reversible-floral-print-poppy',
        'waffle-knit-baby-blanket-36-x-36-100-cotton',
        'heat-pad-goose-gray-small',
        'handmade-baby-bear-white-6-5-plush',
        'lempi-floor-cushion-100cm-sand-polyester-fitwood',
        'lumo-play-canopy-vanilla'
      ]
    }
  ];

  function blobOf(product) {
    return [
      product.handle || '',
      product.title || '',
      product.vendor || '',
      Array.isArray(product.tags) ? product.tags.join(' ') : (product.tags || '')
    ].join(' ').toLowerCase();
  }

  function containsAny(blob, terms) {
    if (!terms || !terms.length) return false;
    for (var i = 0; i < terms.length; i++) {
      if (blob.indexOf(String(terms[i]).toLowerCase()) !== -1) return true;
    }
    return false;
  }

  function ruleMatches(rule, product) {
    var handle = String(product.handle || '').toLowerCase();
    var vendor = String(product.vendor || '').toLowerCase();
    var blob = blobOf(product);
    var match = rule.match || {};
    var exclude = rule.exclude || {};
    if (containsAny(blob, exclude.any)) return false;
    if (match.from && match.from.length) {
      var from = String(product.from || '').toLowerCase();
      if (match.from.indexOf(from) === -1) return false;
    }
    if (match.handles && match.handles.indexOf(handle) !== -1) return true;
    if (match.vendors && match.vendors.indexOf(vendor) !== -1) return true;
    if (containsAny(blob, match.any)) return true;
    return false;
  }

  function unique(list) {
    var seen = {};
    var out = [];
    (list || []).forEach(function (item) {
      var key = String(item || '');
      if (!key || seen[key]) return;
      seen[key] = true;
      out.push(key);
    });
    return out;
  }

  function matchRule(product) {
    if (!product) return null;
    product = Object.assign({}, product);
    if (!product.from && typeof location !== 'undefined' && location.search) {
      try {
        var fromParam = new URLSearchParams(location.search).get('from');
        if (fromParam) product.from = fromParam;
      } catch (e) {}
    }
    var handle = String(product.handle || '').toLowerCase();
    for (var i = 0; i < RULES.length; i++) {
      if (!ruleMatches(RULES[i], product)) continue;
      var addons = unique(RULES[i].addons).filter(function (addon) {
        return addon !== handle;
      });
      if (!addons.length) continue;
      return {
        id: RULES[i].id,
        eyebrow: RULES[i].eyebrow,
        title: RULES[i].title,
        note: RULES[i].note,
        addons: addons
      };
    }
    return null;
  }

  root.RarelyAccessoryMap = {
    rules: RULES,
    match: matchRule
  };
})(typeof window !== 'undefined' ? window : this);
